import Quill from 'quill';

const BlockEmbedBlot = Quill.import('blots/block/embed');

class EmbedlyBlot extends BlockEmbedBlot {
  static blotName = 'embedly';
  static className = 'embedly-embed';
  static tagName = 'IFRAME';

  // Create HTML node
  static create(value) {
    const node = super.create();

    const template = document.createElement('template');

    template.innerHTML = value;
    const iframe = template.content.firstChild;

    node.setAttribute('src', iframe.src);
    node.setAttribute('frameborder', iframe.frameBorder);
    node.setAttribute('allowfullscreen', iframe.allowFullScreen);
    node.setAttribute('width', iframe.width);
    node.setAttribute('style', iframe.style.cssText);
    node.setAttribute('scrolling', iframe.scrolling);

    return node;
  }

  // Convert HTML node to value
  static value(node) {
    return node.outerHTML;
  }
}

export default EmbedlyBlot;
